export default __webpack_public_path__ + "static/media/phone.50514af3.svg";